export const load = () => ({
	title: 'Energy Saving Window Solutions',
	h1: 'Reduce Energy Costs With Insulating Window Inserts',
	description:
		'Save money on energy bills by insulating your windows against temperature loss through every season.',
	showTitle: true,
});
